<script lang="ts">
	import { onMount } from 'svelte';
	import { VpIconButton } from '@vtmn-play/svelte/VpIconButton';
	import { VpIcon } from '@vtmn-play/svelte/VpIcon';
	import { UserService } from '../../../../domain-services/User.service';
	import { UserRoleEnum } from '../../../../interfaces/UserRoleEnum';
	import { _ } from '../../../../utility-services/Translation.service';

	const userService = new UserService();

	let isAdmin = $state(false);

	onMount(async () => {
		try {
			const rights = await userService.getUserRights();
			isAdmin = rights.some((right) => right.category === UserRoleEnum.Admin);
		} catch (error) {
			isAdmin = false;
		}
	});
</script>

{#if isAdmin}
	<VpIconButton
		variant="ghost"
		size="medium"
		altText={$_('admin_dashboard_access')}
		data-testid="admin-access-button"
		href="/admin"
	>
		<VpIcon name="settings" size={20} />
	</VpIconButton>
{/if}
